import { render, staticRenderFns } from "./PShadowBevel.vue?vue&type=template&id=22bddafa&scoped=true"
import script from "./PShadowBevel.vue?vue&type=script&lang=js"
export * from "./PShadowBevel.vue?vue&type=script&lang=js"
import style0 from "./PShadowBevel.vue?vue&type=style&index=0&id=22bddafa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bddafa",
  null
  
)

export default component.exports